module.exports = __webpack_public_path__ + "static/media/chegg_logo.d335be56.png";